import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import { isEmpty } from "lodash";

import { getTotalPrice } from "../../store/sagas/selectors";

const ConfiguratorTotalPriceRow = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    white-space: nowrap;
`;

const ConfiguratorTotalPriceSeparatorBox = styled.span`
    ${({ theme }) => theme.bp.xs`
        padding: .8vw;
    `};
    ${({ theme }) => theme.bp.sm`
        padding: .4vw;
    `};
`;

const ConfiguratorTotalPriceValueBox = styled.div`
    font-size: 1.4em;
    padding: 1px 4px 2px;
    margin: 2px;
    background-color: #636363;
    display: inline-block;
    color: #fff;
    line-height: 1;
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.9em;
                `}
`;

const ConfiguratorTotalPriceCurrency = styled.div`
    font-size: 1.4em;
    padding: 1px 4px 2px;
    margin: 2px;
    display: inline-block;
    color: #636363;
    line-height: 1;
`;

export const ConfiguratorTotalPrice = () => {
    const totalPrice = useSelector(getTotalPrice);

    if (!totalPrice) return null;

    const raw = totalPrice.priceValue;
    if (typeof raw !== "number" || !Number.isFinite(raw) || raw === 0) {
        return null;
    }

    const values = Math.round(raw).toLocaleString("sv-SE").split("");
    if (!values) return null;

    const digits = values.map((x: string, index: number) => {
        return isEmpty(x.trim()) ? (
            <ConfiguratorTotalPriceSeparatorBox key={`${x}${index + 1}`} />
        ) : (
            // The linter complains if the index is used
            <ConfiguratorTotalPriceValueBox key={`${x}${index + 1}`}>{x}</ConfiguratorTotalPriceValueBox>
        );
    });

    const content = totalPrice.currencyIsPrefixed ? (
        <>
            <ConfiguratorTotalPriceCurrency>{totalPrice.currencySymbol} </ConfiguratorTotalPriceCurrency>
            {digits}
        </>
    ) : (
        <>
            {digits}
            <ConfiguratorTotalPriceCurrency>{totalPrice.currencySymbol} </ConfiguratorTotalPriceCurrency>
        </>
    );

    return <ConfiguratorTotalPriceRow>{content}</ConfiguratorTotalPriceRow>;
};
